import React from "react"

const WaterIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        d="M4.25 7.625L5.56439 20.3308C5.66985 21.3502 6.52889 22.125 7.55378 22.125H15.94C16.9675 22.125 17.8279 21.3464 17.9301 20.324L19.25 7.125M4.25 7.625L3.75 2.125H19.75L19.25 7.125M4.25 7.625C5.16494 6.97984 6.91655 6.5 8.75 6.5C11.8804 6.5 12.3152 8 14.75 8C17.1848 8 19.25 7.125 19.25 7.125"
        stroke="black"
        strokeWidth="1.8"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export default WaterIcon
